export default __webpack_public_path__ + "static/media/screenshot_1.7647c4e2.svg";